<template>
    <div class="single-collection">
        <Banner
            v-if="!!singleCollection"
            :duration="durationOfCollection"
            :collection="singleCollection"
            :courses="courses"
            :showFinishProgress="isLoggedIn"
        />
        <div class="page-content" v-if="singleCollection">
            <div v-for="(detail, index) in connectedFullCourses" :key="index" class="single-collection__item">
                <div class="single-collection__section" v-if="detail.itemType === 'label'" >
                    <h2 class="single-collection__subtitle">{{ detail.title }}</h2>
                    <p class="single-collection__description">{{ detail.description }}</p>
                </div>
                <SingleCollectionItem
                    :course="detail"
                    :amountOfCourses="courses.length"
                    :index="index"
                />
            </div>
        </div>
        <ModalAddToNewWatchlist/>
    </div>
</template>

<script>
    import Banner from 'components/collectionpage/banner/Banner'
    import SingleCollectionItem from 'components/collectionpage/SingleCollectionItem'
    import ModalAddToNewWatchlist from 'components/shared/modals/ModalAddToNewWatchlist'
    import { mapGetters } from 'vuex'
    import routeHelper from 'components/shared/mixins/routeHelper'

    export default {
        mixins: [routeHelper],
        components: {
            Banner,
            SingleCollectionItem,
            ModalAddToNewWatchlist
        },
        metaInfo () {
            return {
                title: this.$t('Collection.course_collection') + ' ' + this.collectionTitle + ' - Eduhouse'
            }
        },
        computed: {
            ...mapGetters({
                'isLoggedIn': 'isLoggedIn',
                'singleCollection': 'CoursesCollections/getSingleCollection',
                'getCourseById': 'Courses/getCourseById'
            }),
            collectionTitle () {
                return (this.singleCollection) ? this.singleCollection.title : ''
            },
            courses () {
                return this.singleCollection.items.filter(el => el.type === 'course')
            },
            connectedFullCourses () {
                return this.singleCollection.items.map((item) => {
                    if (item.type === 'course') {
                        return { ...this.getCourseById(item.id), itemType: item.type }
                    } else {
                        return { ...item, itemType: item.type }
                    }
                })
            },
            durationOfCollection () {
                return this.courses.map(course => this.getCourseById(course.id)).filter(el => !!el).reduce((acc, course) => {
                    return acc + +course.videoDuration
                }, 0)
            }
        },
        methods: {
            async refreshData () {
                try {
                    await Promise.all(
                        [
                            this.$store.dispatch('CoursesCollections/loadSingleCollection', this.$route.params.collectionSlug),
                            this.$store.dispatch('Courses/loadCollectionCourses', this.$route.params.collectionSlug)
                        ]
                    )
                } catch (e) {
                    if (e.code === 404 || e.code === 320 ||
                        e.response.status === 404 || e.response.status === 320) {
                        this.$router.push({ name: 'page-not-found' })
                    }
                    if (e.code === 404 || e.code === 320 ||
                        e.response.status === 403 || e.response.status === 401) {
                        if (this.isLoggedIn) {
                            await this.$router.push({ name: 'page-no-permission' })
                        } else {
                            await this.$router.push({ name: 'login' })
                        }
                    }
                    if (e.code === 410 || e.response.status === 410) {
                        await this.$router.push({ name: 'page-not-found' })
                    }
                    throw e
                }
            }
        },
        async created () {
            const taskName = 'loadingCollectionPage'
            try {
                await this.$store.dispatch('LoaderScreen/addTaskToLoader', {
                    key: taskName,
                    message: 'Loading CollectionPage'
                })
                await this.refreshData()
                if (this.singleCollection.status === 'expired' && this.singleCollection.learningPathId !== null) {
                    this.$router.push({ name: 'page-upgrade-notice', params: { collectionSlug: this.$route.params.collectionSlug } })
                } else if (this.singleCollection.status === 'draft' || this.singleCollection.status === 'expired') {
                    this.$router.push({ name: 'page-not-found' })
                }
            } catch (e) {
            }
            this.$store.dispatch('LoaderScreen/removeTaskFromLoader', taskName)
            this.checkAndSetNewUrlSlug(this.singleCollection, 'collection')
        },
        beforeDestroy () {
            this.$store.dispatch('CoursesCollections/clearSingleCollection')
        },
        watch: {
            isLoggedIn: {
                handler () {
                    if (this.isLoggedIn) {
                        this.$store.dispatch('VideoLog/loadVideoLogs')
                        this.refreshData()
                    }
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .single-collection {
        .page-content {
            padding: 50px 0;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;

            [class*="mobile"] & {
                flex-direction: row;
            }

            [class*="mobile_sm"] & {
                padding: 50px 20px;
            }

            [class*="desktop_x"] & {
                padding: 80px 20px;
            }
        }

        &__item {
            flex: 1;

            [class*="mobile_md"] & {
                border: none;
                margin: calc($gap / 2);
                flex: 0 0 calc(50% - #{$gap});
            }

            [class*="mobile_sm"] & {
                flex: 0 0 100%;
                margin: 0 0 24px;
            }
        }

        &__section {
            margin: 0 0 25px 65px;
        }

        &__subtitle {
            font-size: 2.6rem;
            font-family: Nunito-Bold, sans-serif;
            margin: 0 0 10px;
        }

        &__description {
            font-size: 1.8rem;
        }
    }
</style>
